export const verificationLogConstants ={
    GETALL_REQUEST: 'VERIFICATION_GETALL_REQUEST',
    GETALL_SUCCESS: 'VERIFICATION_GETALL_SUCCESS',
    GETALL_FAILURE: 'VERIFICATION_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'VERIFICATION_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'VERIFICATION_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'VERIFICATION_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}